const { construct } = require('./../../tools/construct')

exports.listAll = async function (state, opts = {}) {
  const constructOpts = {}
  if (opts.date) {
    constructOpts.now = opts.date
  }

  const result = await state.dal.product.listAll(state)
  return result.map(r => construct(r, constructOpts))
}

exports.listAllForDates = async function (state, { dates = [] } = {}) {
  if (dates.length === 0) {
    return []
  }
  const docs = await state.dal.product.listAll(state)
  return dates.map(date => docs.map(d => construct(d, { now: date })))
}
